import {PrepCanvasManager} from "./PrepCanvasManager";
import {useMemo} from "react";
import {ControlItem} from "./ControlItem";

export function PrepControls(props: {
    manager: PrepCanvasManager;
    locked?: boolean;
}) {
    const opts = useMemo(() => {
        return props.manager.options()
    }, [props.manager])

    return (
        <table>
            <tbody>
            {opts.map(o => <ControlItem value={o} locked={props.locked} />)}
            </tbody>
        </table>
    )
}